export {
    GET_ASSESSMENT_TEMPLATE_LIST,
    GET_ASSESSMENT_TEMPLATE_DETAIL,
    USE_ASSESSMENT_TEMPLATE,
    DELETE_ASSESSMENT_TEMPLATE,
    CREATE_ASSESSMENT_TEMPLATE,
} from './assessmentTemplate';
